import React from 'react';
import { Link } from 'react-router-dom';

const HomeView = () => {
  return (
    <div className="relative min-h-[calc(100vh-4rem)] flex items-center justify-center bg-gradient-to-br from-slate-950 via-blue-950 to-slate-900 p-4 sm:p-6 lg:p-8 overflow-hidden">
      {/* Animated Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_70%,transparent_110%)] opacity-20"></div>
      
      {/* Gradient Orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber-500/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-900/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      
      {/* Floating Particles */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-amber-400/40 rounded-full animate-float"></div>
        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-blue-400/40 rounded-full animate-float" style={{ animationDelay: '2s' }}></div>
        <div className="absolute bottom-1/4 left-1/3 w-1.5 h-1.5 bg-amber-300/30 rounded-full animate-float" style={{ animationDelay: '4s' }}></div>
        <div className="absolute top-2/3 right-1/4 w-1 h-1 bg-blue-300/30 rounded-full animate-float" style={{ animationDelay: '3s' }}></div>
      </div>
      
      {/* Desktop/Tablet - Circular Layout */}
      <div className="hidden md:block relative z-10">
        {/* Outer rotating rings */}
        <div className="absolute -inset-4 bg-gradient-to-r from-amber-500 via-yellow-600 to-amber-500 rounded-full animate-spin-slow opacity-30 blur-sm -z-10"></div>
        <div className="absolute -inset-2 bg-gradient-to-l from-blue-900 via-blue-800 to-blue-900 rounded-full animate-spin-reverse opacity-20 blur-sm -z-10"></div>
        
        {/* Glow effect */}
        <div className="absolute -inset-8 bg-gradient-to-r from-amber-500/20 to-blue-900/20 rounded-full blur-2xl animate-pulse -z-20"></div>
        
        {/* Main circle content */}
        <div className="relative w-[300px] h-[300px] md:w-[400px] md:h-[400px] lg:w-[500px] lg:h-[500px] bg-gradient-to-br from-slate-800/90 via-slate-900/90 to-blue-950/90 rounded-full border-2 border-amber-500/20 backdrop-blur-xl flex items-center justify-center shadow-[0_0_50px_rgba(245,158,11,0.2),0_0_100px_rgba(30,58,138,0.1)]">
          {/* Inner shine effect */}
          <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-amber-500/5 to-transparent rounded-full -z-10 overflow-hidden"></div>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_120%,rgba(245,158,11,0.1),transparent_50%)] -z-10 overflow-hidden"></div>
          {/* Center content */}
          <div className="text-center text-white space-y-2 md:space-y-4 px-4 z-10">
            <h1 className="relative text-2xl md:text-3xl lg:text-4xl font-bold">
              <span className="relative bg-clip-text text-transparent bg-gradient-to-r from-amber-400 to-yellow-500">
                <span className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:0.5rem_0.5rem] bg-clip-text text-transparent opacity-30"></span>
                Grupo Cândido
              </span>
            </h1>
            <p className="text-sm md:text-base text-gray-400">Sistema de Gestão</p>
          </div>

          {/* Left Button - Orçamentos */}
          <div className="absolute left-0 -translate-x-1/2 z-20">
            <Link
              to="/admin/quotations"
              className="group relative flex flex-col items-center z-20"
            >
              <div className="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 bg-gradient-to-br from-indigo-800 to-indigo-950 rounded-full flex items-center justify-center transform transition-all duration-300 group-hover:scale-110 group-hover:shadow-[0_0_30px_rgba(67,56,202,0.6)] relative z-20">
                <div className="text-white text-center px-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 md:h-10 md:w-10 lg:h-12 lg:w-12 mx-auto mb-1 md:mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                  <span className="text-xs md:text-sm font-medium">Orçamentos</span>
                </div>
              </div>
              <div className="absolute -bottom-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="px-3 py-1 bg-gray-900/90 rounded-full text-indigo-300 text-xs md:text-sm whitespace-nowrap shadow-lg border border-indigo-900/30">
                  Gerenciar Orçamentos
                </span>
              </div>
            </Link>
          </div>

          {/* Right Button - Clientes */}
          <div className="absolute right-0 translate-x-1/2 z-20">
            <Link
              to="/admin/clients"
              className="group relative flex flex-col items-center z-20"
            >
              <div className="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 bg-gradient-to-br from-amber-600 to-amber-800 rounded-full flex items-center justify-center transform transition-all duration-300 group-hover:scale-110 group-hover:shadow-[0_0_30px_rgba(217,119,6,0.6)] relative z-20">
                <div className="text-white text-center px-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 md:h-10 md:w-10 lg:h-12 lg:w-12 mx-auto mb-1 md:mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  <span className="text-xs md:text-sm font-medium">Clientes</span>
                </div>
              </div>
              <div className="absolute -bottom-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="px-3 py-1 bg-gray-900/90 rounded-full text-amber-400 text-xs md:text-sm whitespace-nowrap shadow-lg border border-amber-600/30">
                  Gerenciar Clientes
                </span>
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile - Card Layout */}
      <div className="md:hidden relative w-full max-w-md mx-auto">
        <div className="text-center text-white mb-8">
          <h1 className="relative text-3xl font-bold mb-2">
            <span className="relative bg-clip-text text-transparent bg-gradient-to-r from-amber-400 to-yellow-500">
              <span className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:0.5rem_0.5rem] bg-clip-text text-transparent opacity-30"></span>
              Grupo Cândido
            </span>
          </h1>
          <p className="text-gray-400">Sistema de Gestão</p>
        </div>

        <div className="space-y-4">
          {/* Orçamentos Card */}
          <Link
            to="/admin/quotations"
            className="block bg-gradient-to-br from-gray-800/90 to-gray-900/90 backdrop-blur-xl rounded-2xl border border-gray-700 p-6 shadow-xl hover:shadow-2xl transition-all duration-300 active:scale-95 hover:border-indigo-800"
          >
            <div className="flex items-center space-x-4">
              <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-indigo-800 to-indigo-950 rounded-full flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
              </div>
              <div className="flex-1 text-left">
                <h3 className="text-xl font-semibold text-white mb-1">Orçamentos</h3>
                <p className="text-sm text-gray-400">Gerenciar orçamentos e pedidos</p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </Link>

          {/* Clientes Card */}
          <Link
            to="/admin/clients"
            className="block bg-gradient-to-br from-gray-800/90 to-gray-900/90 backdrop-blur-xl rounded-2xl border border-gray-700 p-6 shadow-xl hover:shadow-2xl transition-all duration-300 active:scale-95 hover:border-amber-600"
          >
            <div className="flex items-center space-x-4">
              <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-amber-600 to-amber-800 rounded-full flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <div className="flex-1 text-left">
                <h3 className="text-xl font-semibold text-white mb-1">Clientes</h3>
                <p className="text-sm text-gray-400">Gerenciar cadastro de clientes</p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </Link>
        </div>
      </div>

      {/* Decorative Elements - Enhanced */}
      <div className="absolute top-10 left-10 w-32 h-32 bg-amber-500 rounded-full blur-3xl opacity-30 animate-pulse"></div>
      <div className="absolute bottom-10 right-10 w-40 h-40 bg-blue-900 rounded-full blur-3xl opacity-30 animate-pulse" style={{ animationDelay: '1s' }}></div>
      <div className="absolute top-1/2 left-10 w-24 h-24 bg-amber-400 rounded-full blur-3xl opacity-20 animate-pulse" style={{ animationDelay: '2s' }}></div>
      <div className="absolute top-20 right-20 w-28 h-28 bg-blue-800 rounded-full blur-3xl opacity-20 animate-pulse" style={{ animationDelay: '1.5s' }}></div>
      
      {/* Add custom animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0) translateX(0);
            opacity: 0;
          }
          50% {
            opacity: 1;
          }
          100% {
            transform: translateY(-100vh) translateX(20px);
            opacity: 0;
          }
        }
        
        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        
        @keyframes spin-reverse {
          from {
            transform: rotate(360deg);
          }
          to {
            transform: rotate(0deg);
          }
        }
        
        .animate-float {
          animation: float 8s ease-in-out infinite;
        }
        
        .animate-spin-slow {
          animation: spin-slow 20s linear infinite;
        }
        
        .animate-spin-reverse {
          animation: spin-reverse 15s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default HomeView;
